var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RbxFileUpload',{attrs:{"domain":"Tom","reference-id":_vm.id},on:{"uploaded":_vm.onUploaded}}),_c('RbxFileList',{attrs:{"file-list":_vm.documents,"loading":_vm.isLoading},on:{"remove":_vm.onRemove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }